import { useState, useEffect } from 'react';
import { useAgentContext } from '../contexts/AgentContext';

export const useWhatsAppConfig = () => {
  const [webhookUrl, setWebhookUrl] = useState('');
  const [verifyToken, setVerifyToken] = useState('');
  const { user } = useAgentContext();

  useEffect(() => {
    if (user?.id) {
      const backendUrl = import.meta.env.VITE_BACKEND_URL || '';
      setWebhookUrl(`${backendUrl}/api/whatsapp/webhook/${user.id}`);
      fetchVerifyToken();
    }
  }, [user]);

  const fetchVerifyToken = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/api/whatsapp/verify-token`,
        {
          method: 'GET',
          credentials: 'include',
        },
      );

      if (response.ok) {
        const data = await response.json();
        if (data.verifyToken) {
          setVerifyToken(data.verifyToken);
        }
      }
    } catch (error) {
      console.error('Error fetching verify token:', error);
    }
  };

  const handleCopyToClipboard = async (text: string, message: string) => {
    try {
      await navigator.clipboard.writeText(text);
      return message;
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      return 'Error al copiar al portapapeles';
    }
  };

  return {
    webhookUrl,
    verifyToken,
    handleCopyToClipboard,
  };
};
